import type { ReactNode } from 'react';
import { ProgressIndicator } from './ProgressIndicator/ProgressIndicator';

interface IProgressBar {
    feedback?: ReactNode;
    percentage: number;
    statusText: string;
    title: ReactNode;
}

export function ProgressBar(props: Readonly<IProgressBar>) {
    return (
        <div className="row align-items-center py-1">
            <div className="col-sm-12">{props.title}</div>
            <div className="col-sm-12">
                <ProgressIndicator
                    percentage={Math.floor(props.percentage)}
                    statusText={props.statusText}
                ></ProgressIndicator>
            </div>
            {props.feedback}
        </div>
    );
}
